import ApiService from "@/api/baseApi/api-service";
import { Config } from "../../config";
import {
  IBlogsGetAllParams,
  IGetAllBlogs,
  IGetBlogsCategories,
  IGetBlogDetails,
  IGetAllBlogComments,
  ISubmitCommentResponse,
  IGetAllBlogCommentsParams,
  IPostBlogCommentLikeToggle,
  IPostBlogCommentDislikeToggle,
  IBlogLikeToggle,
  IGetAuthorsParams,
  IGetAuthorsResponse,
} from "./interfaces/IBlogs";
const subBaseURL = "/blogs";
const subBaseCategoriesUrl = "/blogs-categories";
const URLs = {
  getBlogs: subBaseURL,
  getBlogDetails: subBaseURL + "/",
  getBlogsCategories: subBaseCategoriesUrl,
  getBlogComments: "/comments",
  getCommentReplies: "/replies",
  toggleLike: "/toggle-like",
  toggleDisike: "/toggle-dislike",
  subscribeBlogs: "/subscribe-blogs",
  blogReadingTime: "/reading-time",
  getAuthors: "/authors",
};
class ApiBlog extends ApiService {
  constructor(config: Config) {
    super({ ...config });
  }
  getAllBlogs = (params: IBlogsGetAllParams): Promise<IGetAllBlogs> =>
    this.get(URLs.getBlogs, { params });
  getBlogDetails = (slug: string): Promise<IGetBlogDetails> =>
    this.get(URLs.getBlogDetails + slug, {});
  getBlogCategories = (): Promise<IGetBlogsCategories> =>
    this.get(URLs.getBlogsCategories, {});
  getAuthors = (params: IGetAuthorsParams): Promise<IGetAuthorsResponse> =>
    this.get(URLs.getAuthors, { params });
  //?----------- blog-comments -----------
  getAllBlogComments = (
    blogSlug: string,
    params: IGetAllBlogCommentsParams
  ): Promise<IGetAllBlogComments> =>
    this.get(URLs.getBlogDetails + `${blogSlug}` + URLs.getBlogComments, {
      params,
    });
  getAllBlogCommentReplies = (
    blogSlug: string,
    commentID: number,
    params: IGetAllBlogCommentsParams
  ): Promise<IGetAllBlogComments> =>
    this.get(
      URLs.getBlogDetails +
        `${blogSlug}` +
        URLs.getBlogComments +
        `/${commentID}` +
        URLs.getCommentReplies,
      { params }
    );
  submitComment = ({
    blogSlug,
    body,
  }: {
    blogSlug: string;
    body: any;
  }): Promise<ISubmitCommentResponse> =>
    this.post(URLs.getBlogDetails + `${blogSlug}` + URLs.getBlogComments, {
      ...body,
    });
  postCommentLikeToggle = ({
    blogSlug,
    commentID,
    body,
  }: {
    blogSlug: string;
    commentID: number;
    body: any;
  }): Promise<IPostBlogCommentLikeToggle> =>
    this.post(
      URLs.getBlogDetails +
        `${blogSlug}` +
        URLs.getBlogComments +
        `/${commentID}` +
        URLs.toggleLike,
      {
        ...body,
      }
    );
  postCommentDislikeToggle = ({
    blogSlug,
    commentID,
    body,
  }: {
    blogSlug: string;
    commentID: number;
    body?: any;
  }): Promise<IPostBlogCommentDislikeToggle> =>
    this.post(
      URLs.getBlogDetails +
        `${blogSlug}` +
        URLs.getBlogComments +
        `/${commentID}` +
        URLs.toggleDisike,
      {
        ...body,
      }
    );
  subscribeBlogs = (body: any): Promise<any> =>
    this.post(URLs.subscribeBlogs, {
      ...body,
    });
  getBlogLikeToggle = (blogSlug: string): Promise<IBlogLikeToggle> =>
    this.get(URLs.getBlogDetails + `${blogSlug}` + URLs.toggleLike, {});
  postBlogReadingTime = ({
    blogSlug,
    body,
  }: {
    blogSlug: string;
    body: any;
  }): Promise<any> =>
    this.post(URLs.getBlogDetails + `${blogSlug}` + URLs.blogReadingTime, {
      ...body,
    });
}
export default ApiBlog;
